import React from 'react';
export var ConfigContext = React.createContext({
    prefixCls: 'ty',
    componentSize: 'md',
    shimmer: false,
    space: 'sm',
});
//# sourceMappingURL=config-context.js.map